export default __webpack_public_path__ + "static/media/chapter9.61c78292.svg";